import React from 'react';
import { Phone, CheckCircle, AlertTriangle, Wrench } from 'lucide-react';
export function HorseTrailerRepairPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-6684">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-6685">
        <div className="container mx-auto px-4" data-id="element-6686">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-6687">
            Horse Trailer Repair
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-6688">
            Full Horse Trailer Repair and Maintenance Service
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-6689">
        <div className="max-w-6xl mx-auto" data-id="element-6690">
          {/* Services Overview */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6691">
            <div className="grid md:grid-cols-2 gap-8" data-id="element-6692">
              <div data-id="element-6693">
                <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-6694">
                  Complete Horse Trailer Services
                </h2>

                <div className="space-y-3" data-id="element-6695">
                  <div className="flex items-start" data-id="element-6696">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6697" />
                    <span className="text-lg text-gray-700" data-id="element-6698">
                      We Service All brands of Horse Trailers
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6699">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6700" />
                    <span className="text-lg text-gray-700" data-id="element-6701">
                      Welding – frame, sidewall, studs walls, and more
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6702">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6703" />
                    <span className="text-lg text-gray-700" data-id="element-6704">
                      Sheet metal repair
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6705">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6706" />
                    <span className="text-lg text-gray-700" data-id="element-6707">
                      Stall dividers
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6708">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6709" />
                    <span className="text-lg text-gray-700" data-id="element-6710">
                      Horse Trailer Window repair and replacement
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6711">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6712" />
                    <span className="text-lg text-gray-700" data-id="element-6713">
                      Drop down feed, butt side, and more
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6714">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6715" />
                    <span className="text-lg text-gray-700" data-id="element-6716">
                      Ventilation system repairs
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6717">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6718" />
                    <span className="text-lg text-gray-700" data-id="element-6719">
                      Electrical system repair
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6720">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6721" />
                    <span className="text-lg text-gray-700" data-id="element-6722">
                      Axle maintenance and repair
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6723">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6724" />
                    <span className="text-lg text-gray-700" data-id="element-6725">
                      Living quarters repairs, furniture, sofas, dinettes,
                      countertops, cabinets, and more
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6726">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6727" />
                    <span className="text-lg text-gray-700" data-id="element-6728">
                      Appliances A/C, furnaces, water heaters, refrigerators,
                      and more
                    </span>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-center" data-id="element-6729">
                <img src="//drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Flance-815-truck-camper-2008.jpg&site=1986&w=332&h=276&user=1617&opt=w3" alt="Horse Trailer Repair" className="rounded-lg shadow-md" style={{
                width: '332px',
                height: '276px'
              }} data-id="element-6730" />
              </div>
            </div>
          </div>

          {/* Tires, Wheels, Axles Section */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6731">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-6732">
              <Wrench className="mr-3 text-[#B1050B]" size={32} data-id="element-6733" />
              Horse Trailer Tires, Wheels, Axles, Spindles, Brakes Maintenance
            </h2>

            <p className="text-lg text-gray-700 mb-6" data-id="element-6734">
              When it comes to your horses, safety always comes first. Before
              you load your horses into the trailer, be sure to hook up and
              perform a brief inspection of the tires and lights. Keep a tire
              gauge handy and check that the tire is holding the proper pressure
              (known as PSI).
            </p>

            <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 mb-6" data-id="element-6735">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-6736">
                Horse Trailers Carry Valuable Cargo, Always Be On The Lookout
                for Dry Rot.
              </h3>
              <p className="text-gray-700" data-id="element-6737">
                Dry rot appears as tiny cracks in the tire. Dry rot can occur
                even if the tire tread still looks great, and once those cracks
                show up, your tire becomes compromised. And again, remember to
                inspect your spare tires too. Because of dry rot, you should
                plan on replacing tires every three to five years regardless of
                appearance.
              </p>
            </div>

            {/* Tire Images */}
            <div className="flex justify-center gap-4 mb-8" data-id="element-6738">
              <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/horse-trailers/trailer-tire-maintenance.jpg?opt=w3" alt="Trailer tire maintenance" className="rounded-lg shadow-sm" data-id="element-6739" />
              <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/horse-trailers/trailer-tires.jpg300x800.jpg?opt=w3" alt="Trailer tires" className="rounded-lg shadow-sm" data-id="element-6740" />
            </div>
          </div>

          {/* Maintenance Tips */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6741">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-6742">
              Essential Maintenance Tips
            </h2>

            <div className="space-y-8" data-id="element-6743">
              {/* Air Pressure */}
              <div className="border-l-4 border-blue-500 pl-6" data-id="element-6744">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-6745">
                  Check the air pressure in the tires before heading out on a
                  trip.
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-6746">
                  Always check the pressure when the tires are cold. The
                  pressure changes as tires heat up from travel. And don't
                  forget the spare tires. The correct pressure for your horse
                  trailer tires is located right on the tires. Most tire
                  blowouts happen because a tire wasn't properly inflated, so
                  take a few minutes to check before you leave.
                </p>
                <img src="http://tbn0.google.com/images?q=tbn:P03I1xkWvR9SkM:http://www.germes-online.com/direct/dbimage/50312190/Tire_Pressure_Gauge.jpg" alt="Tire pressure gauge" className="border rounded shadow-sm" style={{
                width: '121px',
                height: '121px'
              }} data-id="element-6747" />
              </div>

              {/* Right Tires */}
              <div className="border-l-4 border-green-500 pl-6" data-id="element-6748">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-6749">
                  Make sure you've got the right tires on your horse trailer.
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-6750">
                  Horse trailers require specific tires, primarily because of
                  the load they're carrying. Therefore, use tires rated for the
                  appropriate weight.
                </p>
                <img src="http://tbn1.google.com/images?q=tbn:A1UpoiCSkISb4M:http://static.howstuffworks.com/gif/tire-overloaded.jpg" alt="Overloaded tire" className="border rounded shadow-sm" style={{
                width: '124px',
                height: '93px'
              }} data-id="element-6751" />
              </div>

              {/* Wheel Bearings */}
              <div className="border-l-4 border-purple-500 pl-6" data-id="element-6752">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-6753">
                  Don't forget to inspect wheel bearings.
                </h3>
                <p className="text-gray-700" data-id="element-6754">
                  Wheel bearing failure is a tire-related issue that can happen
                  while you're traveling. To avoid this problem, plan to service
                  your trailer's wheel bearings every 12 months or 12,000 miles,
                  whichever comes first. Moisture buildup seriously affects the
                  bearing grease, which leads to bearing failure. This is why
                  regular service is recommended.
                </p>
              </div>
            </div>
          </div>

          {/* Safety Summary */}
          <div className="bg-red-50 border-2 border-red-500 rounded-lg shadow-md p-8 mb-8" data-id="element-6755">
            <div className="flex items-start" data-id="element-6756">
              <AlertTriangle className="text-red-600 mr-4 flex-shrink-0 mt-1" size={32} data-id="element-6757" />
              <div data-id="element-6758">
                <h2 className="text-2xl font-bold text-red-900 mb-4" data-id="element-6759">
                  Safety First for Your Horses
                </h2>
                <ul className="space-y-2 text-gray-800" data-id="element-6760">
                  <li className="flex items-start" data-id="element-6761">
                    <span className="mr-2" data-id="element-6762">•</span>
                    <span data-id="element-6763">Inspect tires and lights before every trip</span>
                  </li>
                  <li className="flex items-start" data-id="element-6764">
                    <span className="mr-2" data-id="element-6765">•</span>
                    <span data-id="element-6766">
                      Check tire pressure when cold (including spares)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-6767">
                    <span className="mr-2" data-id="element-6768">•</span>
                    <span data-id="element-6769">Look for dry rot cracks in tires</span>
                  </li>
                  <li className="flex items-start" data-id="element-6770">
                    <span className="mr-2" data-id="element-6771">•</span>
                    <span data-id="element-6772">
                      Replace tires every 3-5 years regardless of appearance
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-6773">
                    <span className="mr-2" data-id="element-6774">•</span>
                    <span data-id="element-6775">
                      Service wheel bearings every 12 months or 12,000 miles
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-6776">
                    <span className="mr-2" data-id="element-6777">•</span>
                    <span data-id="element-6778">Use tires rated for appropriate weight</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-6779">
            <h2 className="text-3xl font-bold mb-4" data-id="element-6780">
              Expert Horse Trailer Repair & Maintenance
            </h2>
            <p className="text-xl mb-6" data-id="element-6781">
              Keep your horses safe with professional trailer service
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-6782">
              <Phone className="mr-3" size={24} data-id="element-6783" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-6784">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}